import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL + "/api/ovt/lembur";

export const getLemburList = async (karyawan_id,startdate,enddate) => {
  const params = {};
  if (karyawan_id != null && karyawan_id !== "") {
    params.karyawan_id = karyawan_id;
  }

  if (startdate != null && startdate !== "") {
    params.startdate = startdate;
  }

  if (enddate != null && enddate !== "") {
    params.enddate = enddate;
  }

  const response = await axios.get(BASE_URL, { params });
  return response.data;
};

//Super Admin
export const createLembur = async (data) => {
  const response = await axios.post(`${BASE_URL}/admin`, data);
  return response.data;
};

//Karyawan
export const createLemburByEmp = async (data) => {
  const response = await axios.post(`${BASE_URL}/karyawan`, data);
  return response.data;
};


export const updateLembur = async (id, data) => {
  const response = await axios.put(`${BASE_URL}/${id}`, data);
  return response.data;
};


export const deleteLembur = async (id) => {
  const response = await axios.delete(`${BASE_URL}/${id}`);
  return response.data;
};
